import { toast } from "react-toastify"
import axiosInstance from "../../../services/axios-client"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { MdPending } from "react-icons/md"
import { FaCircleCheck, FaCircleMinus } from "react-icons/fa6"

const useSpmoSummary = () => {
    const [summary, setSummary] = useState()
    const [phase, setPhase] = useState()
    const [loadingPagestate, setLoadingPage] = useState(false)
    const navigate = useNavigate()

    const formatDate = (isoString) => {
        if (!isoString || isoString.startsWith("0001-01-01")) return "N/A"; // Handle null/undefined case
        const date = new Date(isoString);
        return date.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
    };

    const getSummary = async (id, projectID) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/summary-calibrations/spmo?spmoID=${id}&projectID=${projectID}`)
            // console.log(res)
            if (res.status === 200) {
                if (res.data.data.SummaryData === null) {
                    setSummary([])
                } else {
                    let data = []
                    for (const buPerf of res.data.data.SummaryData) {
                        let onePhase = {
                            bu: buPerf.BusinessUnitName,
                            buId: buPerf.BusinessUnitID,
                        }
                        for (const projectPhase of buPerf.ProjectPhaseSummary) {
                            onePhase[`pic${projectPhase.Order}`] = []
                            for (const calibratorData of projectPhase.CalibratorSummarys) {
                                onePhase[`pic${projectPhase.Order}`].push(
                                    <div
                                        key={`${calibratorData.CalibratorID}-${projectPhase.Order}`}
                                        style={{
                                            minHeight: "2.5rem",
                                            padding: "4px 0"
                                        }}
                                    >
                                        <div style={{
                                            display: "grid",
                                            gridTemplateColumns: "minmax(0, 1fr) auto auto",
                                            gap: "8px",
                                            alignItems: "center"
                                        }}>
                                            {/* Text section - can shrink with ellipsis */}
                                            <div style={{
                                                minWidth: 0,
                                                display: "flex",
                                                flexDirection: "column"
                                            }}>
                                                <span style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "small",
                                                    lineHeight: "1.3"
                                                }} title={calibratorData.CalibratorName}>
                                                    {calibratorData.CalibratorName}
                                                </span>
                                                <span style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "small",
                                                    color: "#666",
                                                    lineHeight: "1.3"
                                                }}>
                                                    {formatDate(calibratorData.LastLogin)}
                                                </span>
                                            </div>

                                            {/* Count - fixed width */}
                                            <b style={{
                                                width: "30px",
                                                textAlign: "center",
                                                fontSize: "small"
                                            }}>
                                                {calibratorData.Count}
                                            </b>

                                            {/* Icon - fixed width container that never shrinks */}
                                            <div style={{
                                                width: "25px",
                                                height: "25px",
                                                minWidth: "25px",
                                                minHeight: "25px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                flexShrink: 0,
                                                marginRight: "8px"
                                            }}
                                                onClick={() => navigate(`/spmo-detail/${projectID}/${calibratorData.CalibratorID}/${encodeURIComponent(calibratorData.CalibratorName)}/${buPerf.BusinessUnitID}/${projectPhase.Order}`)}
                                                data-tooltip-id="tooltip-status"
                                            >
                                                {calibratorData.Status === "Pending" && (
                                                    <MdPending color="#FFEA00" size={28} style={{ flexShrink: 0 }} />
                                                )}
                                                {calibratorData.Status === "Completed" && (
                                                    <FaCircleCheck color="#ABE9AF" size={24} style={{ flexShrink: 0 }} />
                                                )}
                                                {calibratorData.Status === "-" && (
                                                    <FaCircleMinus color="gray" size={24} style={{ flexShrink: 0 }} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        }
                        data.push(onePhase)
                    }
                    setSummary(data)
                    setLoadingPage(false)
                }
            }
        } catch (error) {
            if (error.response) {
                setSummary([])
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getPhase = async (projectID) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/projects/project-phase?projectID=${projectID}`)
            if (res.status === 200) {
                setLoadingPage(false)
                setPhase(res.data.data)
            }
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        summary,
        getSummary,
        phase,
        getPhase,
        loadingPagestate
    }
}

export default useSpmoSummary